const _utils = {
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);
    
    observer.observe(node, config);  
    return observer;
  },
  ResizeImageUrl(url, size) {
    return url
      .replace('.webp', `_${size}.webp`)
      .replace('.jpg', `_${size}.jpg`)
      .replace('.jpeg', `_${size}.jpeg`)
      .replace('.png', `_${size}.png`);
  }
};

(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductLifeStyleImages', () => ({
      color_option: null,
      color_option_values: [],
      images_sofa: [],
      images_drapery: [],
      images_linen: [],
      selected_color: '',
      selected_color_index: 0,
      tab_index: 0,
      init() {
        this.InitWatchers();

        this.color_option = JSON.parse(this.$el.dataset.color_option);
        this.color_option_values = JSON.parse(this.$el.dataset.color_option_values);
        this.selected_color = this.$el.dataset.selected_color;
        this.images_sofa = JSON.parse(this.$el.dataset.images_sofa) || [];
        this.images_drapery = JSON.parse(this.$el.dataset.images_drapery) || [];
        this.images_linen = JSON.parse(this.$el.dataset.images_linen) || [];
      },
      InitWatchers() {
        this.$watch('selected_color', () => {
          this.selected_color_index = this.color_option_values.findIndex(color => color.name == this.selected_color);
          let $color_swatch = document.querySelector(`[data-product-options-container] input[value="${this.selected_color}"]`);
          if ($color_swatch && !$color_swatch.checked) {
            $color_swatch.checked = true;
            $color_swatch.dispatchEvent(new Event('change'));
            window.scrollTo({
              top: this.$el.offsetTop,
            })
          }
        });

        window.addEventListener('shopify-variants:switch-variant', (e) => {
          let option_id = `option${this.color_option.position}`;
          this.selected_color = e.detail.variant[option_id];
        });

        _utils.ObserveIntersection(this.$el, {}, (entries) => {
          if (entries[0].isIntersecting) {
            // preload images when section is in view
            this.images_sofa.forEach(image => {
              let img = new Image();
              img.src = this.ResizeImageUrl(image, 'x1200');
            });

            this.images_drapery.forEach(image => {
              let img = new Image();
              img.src = this.ResizeImageUrl(image, 'x1200');
            });

            this.images_linen.forEach(image => {
              let img = new Image();
              img.src = this.ResizeImageUrl(image, 'x1200');
            });
          }
        });

        this.$el.addEventListener('set-tab-index', (e) => {
          this.tab_index = e.detail.tab_index;
        });
      },
      ResizeImageUrl(url, size) {
        return _utils.ResizeImageUrl(url, size);
      },
      e_ScrollToProductForm() {
        window.scrollTo({
          top: document.querySelector('[data-product-form]').offsetTop,
          behavior: 'smooth'
        });
      }      
    }));

    Alpine.data('ProductBuildMe', () => ({
      selected_color_index: 0,
      images: [],
      init() {
        this.InitWatchers();

        this.color_option = JSON.parse(this.$el.dataset.color_option);
        this.images = JSON.parse(this.$el.dataset.images);
        this.selected_color_index = this.$el.dataset.selected_color_index;

        // preload images
        this.images.forEach(image => {
          let img = new Image();
          img.src = this.ResizeImageUrl(image, 'x80');
        });
      },
      InitWatchers() {
        window.addEventListener('shopify-variants:switch-variant', (e) => {
          let option_id = `option${this.color_option.position}`;
          this.selected_color_index = this.color_option.values.indexOf(e.detail.variant[option_id]);
        });
      },
      e_ScrollToLifeStyleImages(tab_index) {
        let $lifeStyleImages = document.querySelector('[data-product-lifestyle-images]');
        if (!$lifeStyleImages) return;

        $lifeStyleImages.dispatchEvent(new CustomEvent('set-tab-index', {
          detail: {
            tab_index: tab_index
          }
        }));
        window.scrollTo({
          top: $lifeStyleImages.offsetTop,
          behavior: 'smooth'
        });
      },
      ResizeImageUrl(url, size) {
        return _utils.ResizeImageUrl(url, size);
      }
    }));

    Alpine.data('per_unit', () => ({
      init() {
        this.InitWatchers();
      },
      InitWatchers() {
        window.addEventListener('shopify-variants:switch-variant', (e) => {
          // console.log(e, this);
          this.$el.textContent = `/Per ${e.detail.variant.option2}`;
        });
      }
    }));
  });
})();